module.exports = __webpack_public_path__ + "static/media/02B.3f0d67c3.png";